export default __webpack_public_path__ + "static/media/elm.4f05d888.svg";